import { P as Component } from './styled';

export const P = Component;
